









import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'AuthBlitzFrame',
  props: {
    src: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Вход',
    },
  },
})
